var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layer-group',{ref:`pop-layer-${_vm.story.id}`},[_c('l-popup',{ref:`pop-${_vm.story.id}`,staticClass:"popup",attrs:{"options":_vm.options}},[_c('div',{staticClass:"card shadow p-1 p-xxl-4",class:`bg-${_vm.story.fields['Story Theme']}`},[_c('PopupIFrame',{attrs:{"story":_vm.story}}),_c('PopupInfo',{attrs:{"story":_vm.story}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }